<div style="height: 100vh; width: 100vw; display: flex; justify-content: center; align-items: center;" >
    <div style="text-align: center;"> 
        <img src="/assets/images/shared/check-icon.svg" alt="" style="height: 120px; width: 120px; margin-bottom: 10px;"> <br>
        <p style="font-weight: bold; margin-top: 7px;">{{ this.pageDetails().title }}</p>
    </div>
</div>
<div style="position: fixed; bottom: 40px; text-align: center; width: 90%; margin: auto; left: 5%;">
    <button type="button" class="btn btn-primary" style="width: 100%; margin: auto;" (click)="this.close()"> {{ this.pageDetails().button }} </button>
</div>
<router-outlet></router-outlet>